'use strict';

import { LODRadial, MapBoxProvider, MapHeightNode, MapNode, MapView, UnitsUtils } from 'geo-three';
import { LinearFilter, LinearMipmapLinearFilter, MeshBasicMaterial, MeshStandardMaterial, Texture } from 'three';
import { threeJsVariables } from '../../../settings';
import { LUT } from '../../post-processing/Passes/LUT';

const basicMaterial = new MeshBasicMaterial();
const standartMaterial = new MeshStandardMaterial();

class StandartMapHeightNode extends MapHeightNode {
	constructor (parentNode, mapView, location, level, x , y, geometry, material) {
		super(parentNode, mapView, location, level, x, y, geometry, material);
		
		this.material = standartMaterial.clone();
		const lut = LUT.getScope('terrain');
		if (lut) {
			lut.include(this.material);
		}
		
	}
}

class BasicMapHeightNode extends MapHeightNode {
	constructor (parentNode, mapView, location, level, x , y, geometry, material) {
		super(parentNode, mapView, location, level, x, y, geometry, material);
		
		this.material = basicMaterial.clone();
		const lut = LUT.getScope('terrain');
		if (lut) {
			lut.include(this.material);
		}
	}
}

MapNode.prototype.loadData = function() {
	return __awaiter(this, void 0, void 0, function* () {
		if (this.level < this.mapView.provider.minZoom || this.level > this.mapView.provider.maxZoom) {
			console.warn('Geo-Three: Loading tile outside of provider range.', this);
			this.material.map = MapNode.defaultTexture;
			this.material.needsUpdate = true;
			return;
		}
		try {
			const image = yield this.mapView.provider.fetchTile(this.level, this.x, this.y);
			if (this.disposed) {
				return;
			}
			const texture = new Texture(image);
			texture.generateMipmaps = false;
			texture.magFilter = LinearFilter;
			texture.minFilter = LinearMipmapLinearFilter;
			texture.anisotropy = threeJsVariables.renderer.capabilities.getMaxAnisotropy();
			texture.needsUpdate = true;
			this.material.map = texture;
		}
		catch (e) {
			if (this.disposed) {
				return;
			}
			console.warn('Geo-Three: Failed to load node tile data.', this);
			this.material.map = MapNode.defaultTexture;
		}
		this.material.needsUpdate = true;
	});
};
MapNode.prototype.nodeReady = function() {
	if (this.disposed) {
		// console.warn('Geo-Three: nodeReady() called for disposed node.', this);
		this.dispose();
		return;
	}
	if (this.parentNode !== null) {
		this.parentNode.nodesLoaded++;
		if (this.parentNode.nodesLoaded === MapNode.childrens) {
			if (this.parentNode.subdivided === true) {
				this.parentNode.isMesh = false;
			}
			for (let i = 0; i < this.parentNode.children.length; i++) {
				this.parentNode.children[i].visible = true;
			}
		}
		if (this.parentNode.nodesLoaded > MapNode.childrens) {
			console.error('Geo-Three: Loaded more children objects than expected.', this.parentNode.nodesLoaded, this);
		}
	}
	else {
		this.visible = true;
	}
}

function __awaiter(thisArg, _arguments, P, generator) {
	function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	return new (P || (P = Promise))(function (resolve, reject) {
		function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
		function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
		function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
		step((generator = generator.apply(thisArg, _arguments || [])).next());
	});
}


export class TilesTerrain {
	constructor (token,lat,lng) {
		this.token = token;
		this.lat = lat;
		this.lng = lng;
	}
	
	load(materialType) {
		
		switch (materialType) {
			case 'MeshStandardMaterial':
				MapView.mapModes.set(MapView.HEIGHT,StandartMapHeightNode);
				break;
			case 'MeshBasicMaterial':
				MapView.mapModes.set(MapView.HEIGHT,BasicMapHeightNode);
				break;
		}
		
		const provider = new MapBoxProvider(this.token, 'mapbox.satellite', MapBoxProvider.MAP_ID, 'jpg70', false);
		const heightProvider = new MapBoxProvider(this.token, 'mapbox.terrain-rgb', MapBoxProvider.MAP_ID, 'pngraw');
		const map = new MapView(MapView.HEIGHT, provider,heightProvider);
		map.material = new MeshBasicMaterial({transparent: true, opacity: 0, depthTest: false});
		map.lod = new LODRadial(40,150);
		
		const coords = UnitsUtils.datumsToSpherical(this.lat, this.lng);
		map.position.set(-coords.x,0,coords.y);
		
		return map;
	}
	
}
